import { USER_JOINED_SITE, USER_COMPLETED_DIALOG_REGISTRATION } from '../actions/types'

const isDialogRegistrationActive = (state = false, action) => {
  switch (action.type) {
    case USER_JOINED_SITE:
      return action.payload
    case USER_COMPLETED_DIALOG_REGISTRATION:
      return false
    default:
      return state
  }
}

export { isDialogRegistrationActive }
